import PropTypes from 'prop-types';
import React from 'react';
import { truncateWithEllipsis } from '../../../../utilities/ui_utilities';
import EmployerCard from '../../../Employer/EmployerCard/EmployerCard';

import './CompanyReviewListItem.scss';

export default class CompanyReviewListItem extends React.PureComponent {
    render() {
        return (
            <div className="component-Layout-ListSection-CompanyReviewListItem">
                <EmployerCard
                    {...this.props.company}
                    shouldLinkToRatings={false}
                    showUnderline={false}
                    linkable={false}
                    companyLogoSize={{ width: 60, height: 60 }}
                />
                <div className="review-text-display">
                    {truncateWithEllipsis(this.props.comment, 60)}
                </div>
            </div>
        );
    }
}

CompanyReviewListItem.defaultProps = {
    reviewId: '',
    company: {},
    comment: '',
    reviewUrl: '',
};

CompanyReviewListItem.propTypes = {
    reviewId: PropTypes.number,
    company: PropTypes.shape({
        companyId: PropTypes.number,
        companyName: PropTypes.string,
        companyUrl: PropTypes.string,
        logo: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
        rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        companyEndpoint: PropTypes.string,
    }),
    comment: PropTypes.string,
    reviewUrl: PropTypes.string,
};
